// extracted by mini-css-extract-plugin
export default {"authRequired":"AuthRequired_authRequired__bPBe6"};